// extracted by mini-css-extract-plugin
export default {"pill":"SecondPillarStatusBox_pill__aI2bq"};